(function () {
    if (typeof window.clarity !== 'undefined') {
        document.addEventListener('cookieConsentGranted', () => {
            window.clarity('consent');
        });
    }
})();
